import React from 'react';
import css from './Checkbox.module.scss';
import {Field} from "formik";
import InputError from "../../../components/common/input-error/InputError";

const CheckboxContent = ({
                           field: {name, value, onChange, onBlur},
                           form: {errors, touched, setFieldValue},
                           id,
                           componentValue,
                           label,
                           customClass,
                           onCheckBoxChange,
                           containerClass,
                           tooltip,
                           ...props
                         }) => {
  return (<React.Fragment>
    <div className={containerClass ? containerClass : ''}>
      <label htmlFor={id}
             className={`${css.checkbox__wrapper} ${customClass ? customClass : ''}`}>
        <div className={css.checkbox__container}>
          <input className={css.checkbox}
                 name={name}
                 id={id}
                 type="checkbox"
                 value={componentValue}
                 checked={componentValue}
                 onChange={(e) => {
                   onChange(e);
                   onCheckBoxChange && onCheckBoxChange(e);
                 }}
                 onBlur={onBlur}/>

          <div className={css.checkbox__styled}>
            <img className={componentValue ? 'fadein' : 'fadeout'}
                 src={'/static/images/pictos/icon-check-primary.svg'}/>
          </div>
        </div>

        <span className={`${css.label}${componentValue ? css.checked : ""}`}>
              {props.children}
          </span>

      </label>
      {!!tooltip && (tooltip)}
    </div>
    <InputError name={name}/>
  </React.Fragment>);
};

const Checkbox = (props) => {
  return (<Field
    component={CheckboxContent}
    name={props.inputName}
    tooltip={props.tooltip}
    customClass={props.customClass}
    containerClass={props.containerClass}
    onCheckBoxChange={props.onChange}
    id={props.inputId}
    componentValue={props.value}
  >
    {props.children}
  </Field>);
};

export default Checkbox;
